<div>
    <div class="deputy-title">
        <h2>{{ 'users.user-profile.deputies' | translate }}</h2>

        <app-button-add caption="{{ 'users.user-profile.add-deputy.title' | translate }}"
            (click)="openAddDeputyDialog()" />
    </div>
    <div class="deputy-list">
        <div *ngFor="let deputy of userDeputies" class="deputy-item">
            <div>
                <b>{{ getUserDisplayName(deputy) }}</b>
            </div>

            <span>
                <button mat-icon-button (click)="openDeleteDeputyDialog(deputy)"
                    matTooltip="{{ 'shared.delete' | translate }}">
                    <mat-icon svgIcon="delete"></mat-icon>
                </button>
            </span>
        </div>
    </div>
</div>